import { useStore } from "../../hooks/mobx";
import { useObserver } from "mobx-react";
import EventStore from "../../stores/EventStore";
import UiStore from "../../stores/UiStore";
import AddDonationStore from "../../stores/AddDonationStore";
import BloodStationStore from "../../stores/BloodStationStore";
import AuthStore from "../../stores/AuthStore";

export const useEventStore = () => {
  const {
    eventStore,
    uiStore,
    addDonationStore,
    bloodStationsStore,
    authStore,
  }: {
    eventStore: EventStore;
    uiStore: UiStore;
    addDonationStore: AddDonationStore;
    bloodStationsStore: BloodStationStore;
    authStore: AuthStore;
  } = useStore([
    "eventStore",
    "uiStore",
    "addDonationStore",
    "bloodStationsStore",
    "authStore",
  ]);
  return useObserver(() => ({
    isLoading: eventStore.isLoading,
    eventData: eventStore.eventData,
    eventID: eventStore.eventID,
    initEvent: eventStore.initEvent,
    eventCategory: eventStore.eventCategory,
    eventDate: eventStore.eventDate,
    eventAuthor: eventStore.eventAuthor,
    eventTimeSlots: eventStore.eventTimeSlots,
    isEventEnded: eventStore.isEventEnded,
    eventPartners: eventStore.eventPartners,
    availableDates: eventStore.availableDates,
    selectedDate: eventStore.selectedDate,
    setSelectedDate: eventStore.setSelectedDate,
    availableTimes: eventStore.availableTimes,
    selectedTime: eventStore.selectedTime,
    setSelectedTime: eventStore.setSelectedTime,
    selectedTimeSlot: eventStore.selectedTimeSlot,
    bloodStationEventsLoading: eventStore.bloodStationEventsLoading,
    setSelectedTimeSlot: eventStore.setSelectedTimeSlot,
    allAvailableTimes: eventStore.allAvailableTimes,
    eventSignUp: eventStore.eventSignUp,
    setLoading: eventStore.setLoading,
    eventUserStatus: eventStore.eventUserStatus,
    eventChangeTimeSlot: eventStore.eventChangeTimeSlot,
    clearEvent: eventStore.clearEvent,
    getAvailableTimesFromDate: eventStore.getAvailableTimesFromDate,
    getEventsForBloodStationById: eventStore.getEventsForBloodStationById,
    bloodStationEvents: eventStore.bloodStationEvents,
    getEventsByBloodStationId: eventStore.getEventsByBloodStationId,
    setIsModalOpen: eventStore.setIsModalOpen,
    setEventID: eventStore.setEventID,
    setEventData: eventStore.setEventData,
    isModalOpen: eventStore.isModalOpen,
    userNotSignedUpBut: eventStore.userNotSignedUpBut,
    getEventTimeSlotByJoinedTimeSlot:
      eventStore.getEventTimeSlotByJoinedTimeSlot,
    eventStore,
    uiStore,
    addDonationStore,
    bloodStationsStore,
    authStore,
  }));
};
